<template>
  <div ref="scroll" v-show="show">
    <slot>
      {{prompt}}
    </slot>
  </div>
</template>

<style scoped>

</style>

<script>
const inViewport = require('in-viewport');

export default {
  name: 'myscroll',
  props: {
    handler: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      prompt: 'Загружается ...',
      show: true,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const it = this;
      let watcher;
      function visible() {
        it.handler()
          .then((repeat) => {
            console.log('repeat', repeat);
            if (repeat) {
              watcher.watch();
            } else {
              it.$emit('done');
              it.show = false;
            }
          })
          .catch((err) => {
            it.prompt = `Error ${err.message}`;
          });
      }
      this.prompt = 'Загружается ...';
      this.show = true;
      watcher = inViewport(this.$refs.scroll, { debounce: 100, offset: 100 }, visible);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my-scroll.vue